/* global axios */
import ApiClient from '../ApiClient';

class TravelPreferences extends ApiClient {
  constructor() {
    super('travel/preferences', { accountScoped: true });
  }

  // A singular resource: the URL has no id segment.
  get() {
    return axios.get(this.url);
  }

  update(preferences) {
    return axios.patch(this.url, { preferences });
  }
}

export default new TravelPreferences();
